import { useMemo } from "react";

export const MOVER = "mover"; //index 1
export const DESPLEGAR = "desplegar"; //index 2
export const MOVERREVES = "girar"; //index 3

/**
 * @description De momento solo hay 2 movimientos y un solo evento (click), pero a futuro me gustaria agregar mas movimientos y eventos
 */
export const useMovesRandom = (cantMoves: number): string[] => {
  const moves: string[] = [];

  for (let index = 0; index < cantMoves; index++) {
    const indexRandomMove = Math.floor(Math.random() * 3);
    if (indexRandomMove == 1) {
      moves.push(MOVER);
    } else if (indexRandomMove == 2) {
      moves.push(DESPLEGAR);
    } else {
      moves.push(MOVERREVES);
    }
  }

  return useMemo(
    () => ({
      ...moves
    }),
    [cantMoves]
  );
};
